import React, { useState, useRef, useEffect, useCallback } from "react";
import ListPageHeader from "../../utilities/ListPageHeader";
import AgGridTable from "../../utilities/AgGridTable";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import { confirmAlert } from "react-confirm-alert";
import {
  Avatar,
  Card,
  CardContent,
  Checkbox,
  Grid,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import Switch from "@mui/material/Switch";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import { debounce } from "lodash";
import { useNavigate } from "react-router-dom";
import DirectoryFilter from "./DirectoryFilter";
import "../expense-claim/expenseClaim.css";

const employeeListUrl = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.employees}`;

const ApprovedCheckbobRenderer = (props) => {
  return <Checkbox defaultChecked={props.data.isApproved} />;
};
const FinancedCheckboxRenderer = (props) => {
  return <Checkbox defaultChecked={props.data.isFinanced} />;
};

const Directory = () => {
  const [open, setOpen] = useState(false);
  const [editRowOpen, setEditRowOpen] = useState(false);
  const [viewRowOpen, setViewRowOpen] = useState(false);
  const [viewRowMainOpen, setViewRowMainOpen] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [addRow, setAddRow] = useState([]);
  const [editRow, setEditRow] = useState([]);
  const [viewRow, setViewRow] = useState([]);
  const [addRowData, setAddRowData] = useState([]);
  const [edit, setEdit] = useState(false);
  const [showPaginationDropdown, setShowPaginationDropdown] = useState(false);
  const [deleteDisable, setDeleteDisable] = useState(true);
  const [selectedRows, setSelectedRows] = useState([]);
  const [tableView, setTableView] = useState(false);
  const gridRef = useRef();
  const perPage = 10;
  const [gridApi, setGridApi] = useState(null);
  const fullNameRenderer = (params) => {
    const name = params.node.data;
    return `${name?.empFirstName} ${name?.empMiddleName} ${name?.empLastName}`;
  };
  const [columnDefs, setColumnDefs] = useState([
    {
      field: "employeeId",
      enableRowGroup: true,
      headerName: "Employee Id",
      filter: "agNumberColumnFilter",
    },
    {
      field: "employeeName",
      headerName: "Employee Name",
      cellRenderer: fullNameRenderer,
    },
    {
      field: "email",
      headerName: "Employee Email",
      // cellRenderer: InventoryCheckboxRenderer,
    },
    {
      field: "designation",
      headerName: "Designation",
    },
    {
      field: "department",
      headerName: "Department",
    },
    {
      field: "location",
      headerName: "Location",
    },
  ]);

  const [error, setError] = useState();
  const [successMsg, setSuccessMsg] = useState();
  const [snackState, setSnackState] = useState(false);
  const navigate = useNavigate();

  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  const loadData = async () => {
    try {
      const list = await OAuthService.getList(employeeListUrl);
      // let employeeList = list.data._embedded.employees.filter(
      //   (item) => item.active === true
      // );
      let employeeList = list.data._embedded.employees;

      setRowData(employeeList);
    } catch (error) {
      setError(error.message);
    }
  };

  useEffect(() => {
    if (gridApi) {
      loadData();
    }
  }, [gridApi]);

  const getContextMenuItems = (event) => {
    var result = [
      {
        name: "Edit",
        icon: '<span><i class="material-icons" style="font-size: 18px">edit</i></span>',
        action: (props) => {
          navigate(`/editEmployee/${event.node.data.employeeId}`);

          // navigate(`/expense-claim/add?id=${event.node.data.id}`);
        },
      },
    ];
    return result;
  };

  const handleEdit = async (
    event,
    values,
    period,
    selectedYear,
    firstDay,
    lastDay,
    selectedCompany,
    companyName
  ) => {
    const id = event?.node?.data?._links?.self?.href.split("/").pop();
    const editRow = {
      id: id,
      companyCode: selectedCompany.value,
      companyName: companyName,
      period: period.label,
      year: selectedYear.value,
      startDate: firstDay,
      endDate: lastDay,
      postingAllowed: values.postingAllowed,
      availableInventory: values.availableInventory,
      pricingAllowed: values.pricingAllowed,
      resetAllowed: values.resetAllowed,
    };
    try {
      if (id) {
        await OAuthService.updateData(url, id, editRow);
        loadData();
        setSuccessMsg("Data Updated Successfully");
        setSnackState(true);
      }
    } catch (error) {
      setError(error.message);
      return;
    }
  };

  const onDelete = useCallback(
    (event) => {
      const selectedRow = [event.node.data];

      confirmAlert({
        title: "Confirm to delete",
        message: "Are you sure to delete.",
        buttons: [
          {
            label: "Yes",
            onClick: () => {
              rowData.splice(event.node.rowIndex, 1);
              gridRef?.current?.api.applyTransaction({ remove: selectedRow });
              selectedRow.map(async (row) => {
                const dataUrl = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.expenseClaimList}`;
                await OAuthService.deleteData(dataUrl, row.id);
                setSuccessMsg("Data deleted Successfully");
                setSnackState(true);
              });
            },
          },
          {
            label: "No",
            onClick: () => {},
          },
        ],
      });
    },
    [gridRef, rowData]
  );

  const handleAddNewRow = async (
    values,
    period,
    selectedYear,
    firstDay,
    lastDay,
    selectedCompany,
    companyName
  ) => {
    const payload = {
      companyCode: selectedCompany.value,
      companyName: companyName,
      period: period.label,
      year: selectedYear.value,
      startDate: firstDay,
      endDate: lastDay,
      postingAllowed: values.postingAllowed,
      availableInventory: values.availableInventory,
      pricingAllowed: values.pricingAllowed,
      resetAllowed: values.resetAllowed,
    };
    await OAuthService.addData(url, payload);
    loadData();
    setSuccessMsg("Data saved Successfully");
    setSnackState(true);
  };

  const handleClearYear = useCallback(() => {
    var countryFilterComponent = gridRef.current.api.getFilterInstance("year");
    countryFilterComponent.setModel(null);
    gridRef.current.api.onFilterChanged();
  }, []);

  const handleSearch = useCallback((value) => {
    const addUrl = `${process.env.REACT_APP_HR_API_KEY_URL}api/expenseClaim/search`;
    OAuthService.addData(addUrl, value)
      .then((resp) => {
        if (resp.data.length !== 0) {
          setRowData(resp.data);
        }
      })
      .catch((error) => setError(error.message));
  }, []);

  const onBtExport = useCallback(() => {
    const params = {
      fileName: "ExpenseClaim.xlsx",
      sheetName: "Expense Claim",
    };
    gridRef.current.api.exportDataAsExcel(params);
  }, []);

  const onRowDoubleClicked = (params) => {
    navigate(`/editEmployee/${params.data.employeeId}`);
  };

  const onSelectionChanged = (params) => {
    setSelectedRows(params.api.getSelectedRows());
  };

  useEffect(() => {
    if (selectedRows.length > 0) {
      setDeleteDisable(false);
    } else {
      setDeleteDisable(true);
    }
  }, [selectedRows]);

  const handleView = () => {
    return (
      <div className="flex justify-end">
        <FormGroup>
          <FormControlLabel
            control={
              <Switch
                color="primary"
                checked={tableView}
                onChange={() => {
                  setTableView(!tableView);
                }}
              />
            }
            label={!tableView ? "Card View" : "Table View"}
          />
        </FormGroup>
      </div>
    );
  };

  let arr = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

  return (
    <>
      <ListPageHeader
        componentName="Payroll"
        pageName="Payroll"
        showPaginationDropdown={false}
        error={error}
        deleteDisable={deleteDisable}
        successMsg={successMsg}
        // gridRef={gridRef}
      />
      <DirectoryFilter
        handleClearYear={handleClearYear}
        handleSearch={handleSearch}
      />
      <div className="h-full pr-12 pl-12 w-full">
        {tableView ? (
          <React.Fragment>
            <React.Fragment>
              <Typography className="flex justify-between mt-3 mb-6">
                FTP (2 EMPLOYEES)
                {handleView()}
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={3}>
                  <Card
                    variant="outlined"
                    onClick={() => {
                      navigate("/payroll/employee/profile");
                    }}
                  >
                    <CardContent>
                      <Grid container spacing={2}>
                        <Grid item xs={2}>
                          <Avatar
                            sx={{
                              width: 26,
                              height: 26,
                              bgcolor: "#ffa726",
                              fontWeight: "bold",
                              fontSize: "1.2rem",
                            }}
                            aria-label="recipe"
                          >
                            GR
                          </Avatar>
                        </Grid>
                        <Grid item xs={10}>
                          <div style={{ fontSize: "16px", fontWeight: "bold" }}>
                            Gokulnath R
                          </div>
                          <div
                            style={{
                              fontSize: "12px",
                              fontWeight: "bold",
                              margin: "4px 0px",
                            }}
                          >
                            2904
                          </div>
                          <div className="flex items-center mute-text">
                            <FuseSvgIcon className="mr-6" size={12}>
                              heroicons-solid:briefcase
                            </FuseSvgIcon>

                            <label style={{ fontSize: "12px" }}>
                              Software Developer
                            </label>
                          </div>

                          <div className="flex items-center mute-text">
                            <FuseSvgIcon className="mr-6" size={12}>
                              heroicons-solid:office-building
                            </FuseSvgIcon>
                            <label style={{ fontSize: "12px" }}>
                              Front-End Developer
                            </label>
                          </div>
                          <div className="flex items-center mute-text">
                            <FuseSvgIcon className="mr-6" size={12}>
                              heroicons-solid:location-marker
                            </FuseSvgIcon>
                            <label style={{ fontSize: "12px" }}>India</label>
                          </div>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={3}>
                  <Card variant="outlined">
                    <CardContent>
                      <Grid container spacing={2}>
                        <Grid item xs={2}>
                          <Avatar
                            sx={{
                              width: 26,
                              height: 26,
                              bgcolor: "#ffa726",
                              fontWeight: "bold",
                              fontSize: "1.2rem",
                            }}
                            aria-label="recipe"
                          >
                            GR
                          </Avatar>
                        </Grid>
                        <Grid item xs={10}>
                          <div style={{ fontSize: "16px", fontWeight: "bold" }}>
                            Gokulnath R
                          </div>
                          <div
                            style={{
                              fontSize: "12px",
                              fontWeight: "bold",
                              margin: "4px 0px",
                            }}
                          >
                            2904
                          </div>
                          <div className="flex items-center mute-text">
                            <FuseSvgIcon className="mr-6" size={12}>
                              heroicons-solid:briefcase
                            </FuseSvgIcon>

                            <label style={{ fontSize: "12px" }}>
                              Software Developer
                            </label>
                          </div>

                          <div className="flex items-center mute-text">
                            <FuseSvgIcon className="mr-6" size={12}>
                              heroicons-solid:office-building
                            </FuseSvgIcon>
                            <label style={{ fontSize: "12px" }}>
                              Front-End Developer
                            </label>
                          </div>
                          <div className="flex items-center mute-text">
                            <FuseSvgIcon className="mr-6" size={12}>
                              heroicons-solid:location-marker
                            </FuseSvgIcon>
                            <label style={{ fontSize: "12px" }}>India</label>
                          </div>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </React.Fragment>
            <React.Fragment>
              <Typography className="my-6">FTFL (3 EMPLOYEES)</Typography>
              <Grid container spacing={2}>
                <Grid item xs={3}>
                  <Card variant="outlined">
                    <CardContent>
                      <Grid container spacing={2}>
                        <Grid item xs={2}>
                          <Avatar
                            sx={{
                              width: 26,
                              height: 26,
                              bgcolor: "#ffa726",
                              fontWeight: "bold",
                              fontSize: "1.2rem",
                            }}
                            aria-label="recipe"
                          >
                            GR
                          </Avatar>
                        </Grid>
                        <Grid item xs={10}>
                          <div style={{ fontSize: "16px", fontWeight: "bold" }}>
                            Gokulnath R
                          </div>
                          <div
                            style={{
                              fontSize: "12px",
                              fontWeight: "bold",
                              margin: "4px 0px",
                            }}
                          >
                            2904
                          </div>
                          <div className="flex items-center mute-text">
                            <FuseSvgIcon className="mr-6" size={12}>
                              heroicons-solid:briefcase
                            </FuseSvgIcon>

                            <label style={{ fontSize: "12px" }}>
                              Software Developer
                            </label>
                          </div>

                          <div className="flex items-center mute-text">
                            <FuseSvgIcon className="mr-6" size={12}>
                              heroicons-solid:office-building
                            </FuseSvgIcon>
                            <label style={{ fontSize: "12px" }}>
                              Front-End Developer
                            </label>
                          </div>
                          <div className="flex items-center mute-text">
                            <FuseSvgIcon className="mr-6" size={12}>
                              heroicons-solid:location-marker
                            </FuseSvgIcon>
                            <label style={{ fontSize: "12px" }}>India</label>
                          </div>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={3}>
                  <Card variant="outlined">
                    <CardContent>
                      <Grid container spacing={2}>
                        <Grid item xs={2}>
                          <Avatar
                            sx={{
                              width: 26,
                              height: 26,
                              bgcolor: "#ffa726",
                              fontWeight: "bold",
                              fontSize: "1.2rem",
                            }}
                            aria-label="recipe"
                          >
                            GR
                          </Avatar>
                        </Grid>
                        <Grid item xs={10}>
                          <div style={{ fontSize: "16px", fontWeight: "bold" }}>
                            Gokulnath R
                          </div>
                          <div
                            style={{
                              fontSize: "12px",
                              fontWeight: "bold",
                              margin: "4px 0px",
                            }}
                          >
                            2904
                          </div>
                          <div className="flex items-center mute-text">
                            <FuseSvgIcon className="mr-6" size={12}>
                              heroicons-solid:briefcase
                            </FuseSvgIcon>

                            <label style={{ fontSize: "12px" }}>
                              Software Developer
                            </label>
                          </div>

                          <div className="flex items-center mute-text">
                            <FuseSvgIcon className="mr-6" size={12}>
                              heroicons-solid:office-building
                            </FuseSvgIcon>
                            <label style={{ fontSize: "12px" }}>
                              Front-End Developer
                            </label>
                          </div>
                          <div className="flex items-center mute-text">
                            <FuseSvgIcon className="mr-6" size={12}>
                              heroicons-solid:location-marker
                            </FuseSvgIcon>
                            <label style={{ fontSize: "12px" }}>India</label>
                          </div>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={3}>
                  <Card variant="outlined">
                    <CardContent>
                      <Grid container spacing={2}>
                        <Grid item xs={2}>
                          <Avatar
                            sx={{
                              width: 26,
                              height: 26,
                              bgcolor: "#ffa726",
                              fontWeight: "bold",
                              fontSize: "1.2rem",
                            }}
                            aria-label="recipe"
                          >
                            GR
                          </Avatar>
                        </Grid>
                        <Grid item xs={10}>
                          <div style={{ fontSize: "16px", fontWeight: "bold" }}>
                            Gokulnath R
                          </div>
                          <div
                            style={{
                              fontSize: "12px",
                              fontWeight: "bold",
                              margin: "4px 0px",
                            }}
                          >
                            2904
                          </div>
                          <div className="flex items-center mute-text">
                            <FuseSvgIcon className="mr-6" size={12}>
                              heroicons-solid:briefcase
                            </FuseSvgIcon>

                            <label style={{ fontSize: "12px" }}>
                              Software Developer
                            </label>
                          </div>

                          <div className="flex items-center mute-text">
                            <FuseSvgIcon className="mr-6" size={12}>
                              heroicons-solid:office-building
                            </FuseSvgIcon>
                            <label style={{ fontSize: "12px" }}>
                              Front-End Developer
                            </label>
                          </div>
                          <div className="flex items-center mute-text">
                            <FuseSvgIcon className="mr-6" size={12}>
                              heroicons-solid:location-marker
                            </FuseSvgIcon>
                            <label style={{ fontSize: "12px" }}>India</label>
                          </div>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </React.Fragment>
            <React.Fragment>
              <Typography className="my-6">
                PTC ({arr.length} EMPLOYEES)
              </Typography>
              <Grid container spacing={2}>
                {arr.map((item) => {
                  return (
                    <Grid item xs={3}>
                      <Card variant="outlined">
                        <CardContent>
                          <Grid container spacing={2}>
                            <Grid item xs={2}>
                              <Avatar
                                sx={{
                                  width: 26,
                                  height: 26,
                                  bgcolor: "#ffa726",
                                  fontWeight: "bold",
                                  fontSize: "1.2rem",
                                }}
                                aria-label="recipe"
                              >
                                GR
                              </Avatar>
                            </Grid>
                            <Grid item xs={10}>
                              <div
                                style={{ fontSize: "16px", fontWeight: "bold" }}
                              >
                                Gokulnath R
                              </div>
                              <div
                                style={{
                                  fontSize: "12px",
                                  fontWeight: "bold",
                                  margin: "4px 0px",
                                }}
                              >
                                2904
                              </div>
                              <div className="flex items-center mute-text">
                                <FuseSvgIcon className="mr-6" size={12}>
                                  heroicons-solid:briefcase
                                </FuseSvgIcon>

                                <label style={{ fontSize: "12px" }}>
                                  Software Developer
                                </label>
                              </div>

                              <div className="flex items-center mute-text">
                                <FuseSvgIcon className="mr-6" size={12}>
                                  heroicons-solid:office-building
                                </FuseSvgIcon>
                                <label style={{ fontSize: "12px" }}>
                                  Front-End Developer
                                </label>
                              </div>
                              <div className="flex items-center mute-text">
                                <FuseSvgIcon className="mr-6" size={12}>
                                  heroicons-solid:location-marker
                                </FuseSvgIcon>
                                <label style={{ fontSize: "12px" }}>
                                  India
                                </label>
                              </div>
                            </Grid>
                          </Grid>
                        </CardContent>
                      </Card>
                    </Grid>
                  );
                })}
              </Grid>
            </React.Fragment>
            <React.Fragment>
              <Typography className="my-6">
                PTH ({arr.length} EMPLOYEES)
              </Typography>
              <Grid container spacing={2}>
                {arr.map((item) => {
                  return (
                    <Grid item xs={3}>
                      <Card variant="outlined">
                        <CardContent>
                          <Grid container spacing={2}>
                            <Grid item xs={2}>
                              <Avatar
                                sx={{
                                  width: 26,
                                  height: 26,
                                  bgcolor: "#ffa726",
                                  fontWeight: "bold",
                                  fontSize: "1.2rem",
                                }}
                                aria-label="recipe"
                              >
                                GR
                              </Avatar>
                            </Grid>
                            <Grid item xs={10}>
                              <div
                                style={{ fontSize: "16px", fontWeight: "bold" }}
                              >
                                Gokulnath R
                              </div>
                              <div
                                style={{
                                  fontSize: "12px",
                                  fontWeight: "bold",
                                  margin: "4px 0px",
                                }}
                              >
                                2904
                              </div>
                              <div className="flex items-center mute-text">
                                <FuseSvgIcon className="mr-6" size={12}>
                                  heroicons-solid:briefcase
                                </FuseSvgIcon>

                                <label style={{ fontSize: "12px" }}>
                                  Software Developer
                                </label>
                              </div>

                              <div className="flex items-center mute-text">
                                <FuseSvgIcon className="mr-6" size={12}>
                                  heroicons-solid:office-building
                                </FuseSvgIcon>
                                <label style={{ fontSize: "12px" }}>
                                  Front-End Developer
                                </label>
                              </div>
                              <div className="flex items-center mute-text">
                                <FuseSvgIcon className="mr-6" size={12}>
                                  heroicons-solid:location-marker
                                </FuseSvgIcon>
                                <label style={{ fontSize: "12px" }}>
                                  India
                                </label>
                              </div>
                            </Grid>
                          </Grid>
                        </CardContent>
                      </Card>
                    </Grid>
                  );
                })}
              </Grid>
            </React.Fragment>
          </React.Fragment>
        ) : (
          <>
            {handleView()}

            <AgGridTable
              columnDefs={columnDefs}
              onGridReady={onGridReady}
              gridRef={gridRef}
              rowData={rowData}
              getContextMenuItems={getContextMenuItems}
              editable={false}
              pagination={false}
              onSelectionChanged={onSelectionChanged}
              onRowDoubleClicked={onRowDoubleClicked}
            />
          </>
        )}
      </div>
    </>
  );
};

export default Directory;
